import React, { FC } from 'react';
import { Button, Space } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { SearchOutlined } from '@ant-design/icons/lib';
import styled from 'styled-components';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';
import { SubpartnersFilterSelect } from 'common/components/SubpartnersSelect';

const StyledSpace = styled(Space)`
  flex-wrap: wrap;
  > * {
    margin-bottom: 0.5rem;
    flex-grow: 1;
    flex-shrink: 1;
    max-width: 200px;
  }
`;

const StyledForm = styled(Form)`
  max-width: 100% !important;
`;

export interface MedicalOperatorsFiltersFormModel {
  firstName?: string;
  lastName?: string;
  email?: string;
  partnerID?: number | undefined;
}

export interface MedicalOperatorsFiltersProps {
  loading?: boolean;
  value?: MedicalOperatorsFiltersFormModel;
  onSubmit: FormikOnSubmit<MedicalOperatorsFiltersFormModel>;
  partnerHardcoded?: string;
  shouldHidePartnerColumn: boolean;
}

export const MedicalOperatorsFilters: FC<MedicalOperatorsFiltersProps> = ({
  onSubmit,
  loading,
  value = {},
  partnerHardcoded,
  shouldHidePartnerColumn,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik initialValues={value} onSubmit={onSubmit} onReset={onSubmit}>
      <StyledForm>
        <StyledSpace>
          <Input
            name="firstName"
            placeholder={intlMessage({ id: 'person.firstName' })}
            style={{ width: 200 }}
          />
          <Input
            name="lastName"
            placeholder={intlMessage({ id: 'person.lastName' })}
            style={{ width: 200 }}
          />
          {!shouldHidePartnerColumn && (
            <SubpartnersFilterSelect
              name="partnerID"
              placeholder={intlMessage({ id: 'partner' })}
              style={{ minWidth: 200, width: '100%' }}
              value={partnerHardcoded}
              disabled={partnerHardcoded ? true : false}
            />
          )}
          <SubmitButton
            type="default"
            loading={loading}
            icon={<SearchOutlined />}
          >
            <FormattedMessage id="search" tagName="span" />
          </SubmitButton>
          <Button id="button-clear-medical-operators-filter" htmlType="reset">
            <FormattedMessage id="clear" tagName="span" />
          </Button>
        </StyledSpace>
      </StyledForm>
    </Formik>
  );
};
